/* API URLS */
export const API_LOCAL_PHOENIX_URL =
  process.env.REACT_APP_LOCAL_PHOENIX_URL ?? 'http://lvh.me:3000';
export const API_LOCAL_MOBILE_URL =
  process.env.REACT_APP_LOCAL_MOBILE_URL ?? 'http://localhost:9001';
export const API_LOCAL_GAMBIT_URL =
  process.env.REACT_APP_LOCAL_GAMBIT_URL ?? 'http://localhost:3004';
export const API_LOCAL_KEYMASTER_URL =
  process.env.REACT_APP_LOCAL_KEYMASTER_URL ?? 'http://localhost:8080';
export const API_LOCAL_CABLE_URL = process.env.REACT_APP_LOCAL_CABLE_URL ?? 'http://localhost:8189';
export const API_LOCAL_BIOMETRICS_URL =
  process.env.REACT_APP_LOCAL_BIOMETRICS_URL ?? 'http://localhost:8083';
export const API_QA_URL = 'https://api.qa.wellframe.com';
export const API_PERF2_URL = 'https://api.perf2.wellframe.com';
export const API_STAGING_URL = 'https://api.staging.wellframe.com';
export const API_PROD_URL = 'https://api.wellframe.com';
export const API_UAT_URL = 'https://api.uat.wellframe.com';
export const API_DEMO_URL = 'https://api.demo.wellframe.com';
export const API_AUTO_URL = 'https://api.auto.wellframe.com';
export const API_TRAINING_URL = 'https://api.training.wellframe.com';
export const API_ORIGIN_URL = window.location.origin;
export const API_DEV_INT_URL = 'https://api.dev.wellframe.com';

export type Environment =
  | 'local'
  | 'staging'
  | 'qa'
  | 'perf2'
  | 'uat'
  | 'demo'
  | 'training'
  | 'auto'
  | 'dev'
  | 'devint'
  | 'production';

/* Environment Configuration Mapping */
export const ENVIRONMENT_CONFIG: { identifier: Environment; url: string }[] = [
  { identifier: 'local', url: API_LOCAL_PHOENIX_URL },
  { identifier: 'staging', url: API_STAGING_URL },
  { identifier: 'qa', url: API_QA_URL },
  { identifier: 'uat', url: API_UAT_URL },
  { identifier: 'demo', url: API_DEMO_URL },
  { identifier: 'training', url: API_TRAINING_URL },
  { identifier: 'auto', url: API_AUTO_URL },
  { identifier: 'devint', url: API_DEV_INT_URL },
  { identifier: 'dev', url: API_ORIGIN_URL },
  { identifier: 'perf2', url: API_PERF2_URL },
];

// Application Header Constants
export const X_WF_CLIENT_APPLICATION = 'X-WF-Client-Application';
export const X_WF_CLIENT_APPLICATION_VALUE = 'member-web';
export const APP_SKU_HEADER = 'App-Sku';
export const X_WELLFRAME_HOSPITAL_ID = 'X-Wellframe-Hospital-Id';

/* Localstorage Keys */
export const LS_ITEM_ACCESS_TOKEN = 'accessToken';
export const LS_ITEM_REFRESH_TOKEN = 'refreshToken';
export const LS_ITEM_OIDC_TOKEN = 'oidcToken';
export const LS_ITEM_IS_LOGGED_IN = 'isLoggedIn';
export const LS_IS_CAREGIVER_WAITING_FOR_APPROVAL = 'isCaregiverPendingApproval';
export const LS_ITEM_SEEN_CARE_PROGRAM_APPROVAL_IDS = 'seenCareProgramApprovalIds';
